const nameSession= 'autofactura-session'

export const session = {
    set(data) {
        try {
            localStorage.setItem(nameSession, JSON.stringify(data));
        } catch (e) {
            console.warn('Error al tratar de guardar la session, ' + e.toString());
        }
    },

    remove() {
        localStorage.removeItem(nameSession);
    },

    get() {
        var session = null;
        try {
            session = JSON.parse(localStorage.getItem(nameSession));
        } catch (e) {
            console.warn('Error al tratar de obtener  la session, ' + e.toString());
        }
        return session;
    },

    removeValue(key) {
        var session = this.get();
        if (!session)
            throw new Error("Session Inexistente");
        delete session[key];
        this.set(session);
    },

    setValue(key, value) {
        var session = this.get();
        if (!session)
            throw new Error("Session Inexistente");
        session[key] = value;
        this.set(session);
    },

    getValue(key) {
        if(this.get()) {
            if (!this.get()[key])
                return false;
            return this.get()[key];
        }
    }

};
